import axios from 'axios';

export const listAdminInventory = async ({ headers, eventId }) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_INVENTORY_BASE_URL}/admin/list?eventId=${eventId}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const updateInventoryMany = async ({ headers, payload }) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_INVENTORY_BASE_URL}/update/many`,
      payload,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const removeFromInventory = async ({ headers, payload }) => {
  try {
    const response = await axios.delete(`${process.env.REACT_APP_API_INVENTORY_BASE_URL}/remove`, {
      headers,
      data: payload
    });
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};
